import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Utility } from 'src/app/core/common';
import { JobService } from 'src/app/services/job.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-job-advertise',
  templateUrl: './job-advertise.component.html',
  styleUrls: ['./job-advertise.component.scss']
})
export class JobAdvertiseComponent implements OnInit {
  Utility = Utility;

  advertise: any;
  jobs: any[];
  total: number;
  constructor(private route: ActivatedRoute, private jobService: JobService, 
    private toastr: ToastrService, private analyticsService: AnalyticsService, 
    private spinner: SpinnerService) { }

  async ngOnInit() {
    this.spinner.show('job-advertise');
    var result = await this.jobService.getAdvertise(this.route.snapshot.params.adId);
    this.spinner.hide('job-advertise');
    this.advertise = result.advertise;
    this.jobs = result.jobs?.jobs;
    this.total = result.jobs?.total;

    this.analyticsService.gtmEvent('advertise-detail', 'seeker', this.advertise?.Title || this.advertise?.Id);

  }

  share() {
    if ((<any>navigator).share) {
      (<any>navigator).share({
        title: 'به نظرم این شغل برات مناسبه',
        url: window.location.href
      }// ).then(() => this.toastr.info('با تشکر از اشتراک گذاری')
      ).catch(() => this.copy());
    } else {
      this.copy();
    }
    this.analyticsService.gtmEvent('advertise-share', 'seeker', this.advertise?.Title || this.advertise?.Id);
  }
  copy() {
    if (Utility.setClipboard(window.location.href)) {
      this.toastr.success('آدرس صفحه کپی شد.');
    }
  }

}
